import React, { useEffect, useState } from "react";
import OrderPills from "../../../../../atoms/Pills/OrderPills";
import { ParseDate, ParseDateTime } from "../../../../../../../helpers/Parsers";

import styles from "./TableItemMobile.module.scss";
import { OrderService } from "services/OrderService";
import i18n from "i18n";
export const RequestOrderItemMobile = ({
  requestOrder,
  handleClick,
  mapTypes,
}) => {
        const prueba = e => {
          handleClick(e);
        };

        const [destination, setDestination] = useState("");

        useEffect(() => {
          if (requestOrder.order) {
            getDetination();
          }
        }, []);

        /**
         * Fetches destination details asynchronously.
         * Since this is a nested detail, we handle it as a side-effect to
         * avoid overloading the main table request.
         */
        const getDetination = () => {
          OrderService.relocationOrder(requestOrder.order.id)
            .then(order => {
              if (order && order.destination) {
                setDestination(order.destination.name);
              }
            })
            .catch(err => {
              setDestination("-");
            });
        };

        return (
          <div
            className={`${styles["prep-order-table-item-mobile-container"]} ${
              requestOrder.order ? styles.destination : ""
            }`}
            data-automation-id="prep-order-table-item"
            data-requestorder-id={requestOrder.id}
            onClick={prueba}
          >
            <div className={styles["prep-order-table-item-mobile-klass"]}>
              {mapTypes && mapTypes[requestOrder.klass]}
            </div>

            <div className={styles["prep-order-table-item-mobile-code"]}>
              Nro {requestOrder.code}
            </div>

            <div className={styles["prep-order-table-item-mobile-date"]}>
              {i18n.t("date")}: {ParseDate(requestOrder.created_at)}
            </div>

            {requestOrder.order && (
              <div className={styles["prep-order-table-item-mobile-date"]}>
                Destino: {destination}
              </div>
            )}

            <div className={styles["prep-order-table-item-mobile-bottom"]}>
              <div className={styles["prep-order-table-item-mobile-owner"]}>
                {i18n.t("owner")}:{" "}
                {requestOrder.owner
                  ? `${requestOrder.owner.first_name} ${requestOrder.owner.last_name}`
                  : "-"}
              </div>
              <div
                className={styles["prep-order-table-item-mobile-state-inner"]}
              >
                <OrderPills state={requestOrder.status}></OrderPills>
              </div>
            </div>
          </div>
        );
      };

export default RequestOrderItemMobile;
